export default __webpack_public_path__ + "static/media/inviteSignup3.33c6b992.svg";